import React from 'react';
// Use the JSX intrinsic element <pixiText />
// Import TextStyle from pixi.js if needed for complex style objects,
// or define style directly in props.
import { TextStyle } from 'pixi.js'; 
import type { TextStyleAlign } from 'pixi.js';


interface ScoreDisplayComponentProps {
  score: number;
  x?: number; // Optional position props, can default or be calculated
  y?: number;
  anchorX?: number;
  anchorY?: number;
  textStyle?: Partial<TextStyle>; // Allow overriding default style
}

const DEFAULT_SCORE_TEXT_STYLE = new TextStyle({
    fontFamily: '"Press Start 2P", Courier, monospace', // A common pixel/retro font
    fontSize: 36,
    fill: 0xffffff, // White
    stroke: { color: 0x000000, width: 4, join: 'round' as const }, // Black outline, added 'as const'
    align: 'center' as TextStyleAlign, // Explicitly cast for TextStyleAlign
});

const ScoreDisplayComponent: React.FC<ScoreDisplayComponentProps> = ({
  score,
  x = 0, // Default to 0, GameComponent will position it
  y = 0,
  anchorX = 0.5, // Default to center anchor for x
  anchorY = 0,   // Default to top anchor for y
  textStyle,
}) => {
  const combinedStyle = { ...DEFAULT_SCORE_TEXT_STYLE, ...textStyle };

  return (
    <pixiText
      text={`${score}`} 
      anchor={{ x: anchorX, y: anchorY }}
      x={x}
      y={y}
      style={combinedStyle}
      zIndex={10} // ADDED zIndex to be above pipes (zIndex 5)
    />
  );
};

export default ScoreDisplayComponent;
// Rewrite Count: 2